/**
 * Governance Constants — Source of Truth for frontend
 * 
 * CRITICAL: The global baseline scenario is `zero_normal` (Normal sem investimento).
 * All governance modules (Financeiro, Investidores, Projetos, Comercial, RH, Swim Vision)
 * must use this as the default scenario unless explicitly overridden by the user.
 */

// ─── Baseline Scenario ──────────────────────────────────────────────────────
export const BASELINE_SCENARIO_KEY = 'zero_normal';
export const BASELINE_SCENARIO_LABEL = 'Normal sem investimento';

// ─── Scenario Matrix (3 Investment × 3 Operation) ───────────────────────────
export const INVESTMENT_LEVELS = [
  { key: 'zero', label: 'Sem Investimento (Bootstrap)', amount: 0 },
  { key: 'seed_250k', label: 'Seed R$ 1.3M (~USD 250K)', amount: 1300000 },
  { key: 'seed_500k', label: 'Seed + Series A R$ 9.3M', amount: 9300000 },
];

export const OPERATION_CASES = [
  { key: 'pessimista', label: 'Pessimista' },
  { key: 'normal', label: 'Normal' },
  { key: 'otimista', label: 'Otimista' },
];

/**
 * Generates the 9 scenario keys from the matrix
 */
export const ALL_SCENARIO_KEYS = INVESTMENT_LEVELS.flatMap(inv =>
  OPERATION_CASES.map(op => `${inv.key}_${op.key}`)
);

/**
 * Human-readable display name for a scenario key
 */
export const getScenarioDisplayName = (key) => {
  if (!key) return BASELINE_SCENARIO_LABEL;
  const [invKey, opKey] = key.split('_').length === 2
    ? key.split('_')
    : [key.substring(0, key.lastIndexOf('_')), key.substring(key.lastIndexOf('_') + 1)];
  const inv = INVESTMENT_LEVELS.find(i => i.key === invKey);
  const op = OPERATION_CASES.find(o => o.key === opKey);
  if (!inv || !op) return key;
  return `${inv.label} — ${op.label}`;
};

// ─── Data Source Indicator ──────────────────────────────────────────────────
export const DATA_SOURCE = {
  API: 'api',
  FALLBACK: 'fallback',
  EMPTY: 'empty',
};
